<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="25"
        (click)="folderClick(node)" [ngClass]="{ 'active': activeNode === node }">
        <button mat-icon-button disabled></button>
        <mat-icon class="folder-icon">
            folder
        </mat-icon>
        {{node.name}}
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="25"
        (click)="folderClick(node)" [ngClass]="{ 'active': activeNode === node }">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon>
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <mat-icon class="folder-icon">
            folder
        </mat-icon>
        {{node.name}}
    </mat-tree-node>
</mat-tree>